/**
 * /devhub/platform — Platform (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (ControlPlanePlatformPanel) — spokes/plugins, ToolGateway, evidence, persistence.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { ControlPlanePlatformPanel } from '../features/control-plane/ControlPlanePlatformPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/platform')({ component: PlatformPage });

function PlatformPage() {
  return (
    <DevHubPanelPage
      title="Platform"
      subtitle="Spokes / plugins, ToolGateway, evidence and persistence."
      status={{ label: 'live', live: true }}
    >
      <ControlPlanePlatformPanel />
    </DevHubPanelPage>
  );
}
